import { useEffect, useState } from "react";
import { formatDistanceToNowStrict } from "date-fns";

/** "3 minutes ago", re-rendered every few seconds on its own. */
export function RelativeTime({
  at,
  className,
}: {
  at: string | number | null | undefined;
  className?: string;
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), 5000);
    return () => window.clearInterval(id);
  }, []);
  if (!at) return <span className={className}>—</span>;
  const date = new Date(at);
  return (
    <time dateTime={date.toISOString()} title={date.toLocaleString()} className={className}>
      {formatDistanceToNowStrict(date, { addSuffix: true })}
    </time>
  );
}
